"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _svgosm = require("./svgosm.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

/**
 * Generates our dedicated Icon component.
 *
 * @param {String} displayName Name of the Icon.
 * @returns {React.Component} The React Component.
 * @public
 */
module.exports = function create(displayName) {
  /**
   * The base component that renders the Icon.
   *
   * @constructor
   * @param {Object} props All the props
   * @param {Number} props.width Width of the icon.
   * @param {Number} props.height Height of the icon.
   * @param {String} props.className Class name of the icon.
   * @param {String} props.title A11y title of the icon.
   * @param {String} props.desc A11y description of the icon.
   * @param {String} props.role A11y role for the icon.
   * @param {Object} props.props The rest of the props that are spread on the <use> tag.
   * @param {React.Ref} ref Forwarding reference
   * @private
   */
  const Fwd = /*#__PURE__*/_react.default.forwardRef(function Icon(_ref, ref) {
    let {
      width,
      height,
      className,
      title,
      desc,
      role
    } = _ref,
        props = (0, _objectWithoutProperties2.default)(_ref, ["width", "height", "className", "title", "desc", "role"]);
    const [failed, again] = (0, _react.useState)(null);

    const res = _svgosm.svgosm.get(displayName, function extract() {
      const details = _svgosm.svgosm.extract(`uxp-icon-${displayName}`);

      if (!details) return;
      return Object.assign(details, {
        title: title,
        desc: desc
      });
    }); //
    // Allows us to forcefully trigger a re-render of the Icon in the case
    // where styles would be loaded after the JavaScript is executed. E.g.
    // in the case that CSS in manually injected using React so we can't read
    // it out until an initial render of a component has taken place.
    //
    // This is one time fail safe only per component to prevent too many
    // re-render attempts.
    //


    (0, _react.useEffect)(function retry() {
      if (res || failed) return;
      again(true);
    }, []);
    if (!res) return null;
    const svg = {
      className: ['uxicon-svg-container', className].join(' '),
      height: height || res.height,
      width: width || res.width,
      role,
      ref
    };
    return /*#__PURE__*/_react.default.createElement("svg", svg, /*#__PURE__*/_react.default.createElement("use", (0, _extends2.default)({
      fill: "currentColor"
    }, props, {
      xlinkHref: res.link
    })));
  }); //
  // Ease debugging.
  //


  Fwd.displayName = displayName + 'Icon';
  /**
   * PropType validation.
   *
   * @type {Object}
   * @private
   */

  Fwd.propTypes = {
    width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
    className: _propTypes.default.string,
    desc: _propTypes.default.string,
    title: _propTypes.default.string,
    role: _propTypes.default.string
  };
  /**
   * Default properties.
   *
   * @type {Object}
   * @private
   */

  Fwd.defaultProps = {
    role: 'img',
    width: '1.5em',
    height: '1.5em'
  };
  return Fwd;
};